import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'rdata',
    standalone: false
})
export class RdataPipe implements PipeTransform {

  currencyFields = {
    'salary': 1,
    'signingBonus': 1,
    'cmeAllowance': 1,
    'relocationBonus': 1,
    'qualityBonus': 1,
    'duesLicensePaid': 1,
    'guaranteedCompensation':1
  };

  timeFields = {
    'cmeTime': 1,
    'pto': 1
  };

  transform(value: number | string | boolean, dataPoint: string, productivityBonusType?: 'Dollars' | 'WRVU'): string | number {
    if (value === null || undefined) return '-';
    if (this.currencyFields.hasOwnProperty(dataPoint)) {
      return this.formatCurrency(+value);
    }
    if (this.timeFields.hasOwnProperty(dataPoint)) {
      return this.pluralizePostfix(+value, 'week')
    }
    switch(dataPoint) {
      case 'nonCompeteDistance':
        return this.pluralizePostfix(+value, 'mile');
      case 'nonCompeteMiles':
        return this.pluralizePostfix(+value, 'mile');        
      case 'tailCoverage':
        return this.handleTailCoverage(value.toString());
      case 'productionBonusType':
        return this.handleBonusType(value.toString());
      case 'bonusRate':
        return this.getBonusRateFormat(productivityBonusType) === 'percent' ? new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(+value!) + '%' : this.getBonusRateFormat(productivityBonusType)  === 'currency' ? this.formatCurrency(+value!) : '-';
      case 'productionBonusRatio':
        return new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(+value!) + '%';
      case 'dollarsPerWrvu':
        return this.formatCurrency(+value!);
      case 'collectionsThreshold':
        return this.formatCurrency(+value!);
      case 'wrvuThreshold':
        return new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(+value!);
      case 'bonusThreshold':
        return this.getBonusThresholdFormat(productivityBonusType) === 'currency' ? this.formatCurrency(+value!) : new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(+value!);
      case 'practiceType':
        return this.handlePracticeType(value.toString());
      case 'nonCompeteExclusions':
        return value === true ? 'Yes' : 'No';
      case 'positionType':
        return this.handlePositionType(value.toString());
      case 'ptoHours':
        return this.pluralizePostfix(+value, 'week');
      default:
        return value?.toString();
      }
    }

    pluralizePostfix(value: number, postfix: string) {
      return value === 1 ? value + ' ' + postfix : value + ' ' + postfix + 's';
    }

    formatCurrency(value: number): string {
      let minDigits = 0;
      if(value % 1 !== 0) {
        minDigits = 2;
      }

      return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: minDigits, maximumFractionDigits: 2}).format(value);
    }

    handleTailCoverage(value: string): string {
      switch(value) {
        case 'EmployeePaid':
          return 'Employee Paid';
        case 'EmployerPaid':
          return 'Employer Paid';
        case 'SharedCost':
          return 'Shared Cost';
        case 'CoveredByEmployer':
          return 'Employer Paid';
        case 'CoveredByPhysician':
          return 'Employee Paid';
        case 'VestingSchedule':
          return 'Vesting Schedule';
        case 'VariesBasedOnTermination':
          return 'Varies based on termination';
        default:
          return value
      }
    }

    handleBonusType(value: string): string {
      return value === 'Dollars' ? 'Total Collections' : 'Work RVU'
    }

    getBonusRateFormat(productivityBonusType: string): 'percent' | 'currency' {
      return productivityBonusType.toLocaleLowerCase() === 'dollars' ? 'percent' : 'currency';
    }
  
    getBonusThresholdFormat(productivityBonusType: string): 'currency' | 'number' {
      return productivityBonusType.toLocaleLowerCase() === 'dollars' ? 'currency' : 'number';
    }

    handlePracticeType(value: string): string {
      switch(value.toLowerCase()) {
        case 'academic':
          return 'Academic';
        case 'hospital':
          return 'Hospital/Health System';
        case 'privatepractice':
          return 'Physician Owned/Private Practice';
        case 'government':
          return 'Government/VA/FQHC';
        case 'other':
          return 'Other/Private Equity';
        default:
          return value;
      }
    }

    handlePositionType(value: string): string {
      switch(value.toLowerCase()) {
        case 'fulltime':
          return 'Full-time';
        case 'parttime':
          return 'Part-time';
        default:
          return value;
      }
    }
}
